import api from './api';

const endpoint = '/api/v1/ecommerce/pricing';

export default {

    async get(isEcommerce = false) {
        const rentnow = isEcommerce ? 1 : 0;
        return await api.get(`${endpoint}?rentnow=${rentnow}`);
    },

    async getNonEcommercePricing() {
        return this.get(false);
    },


    async getEcommercePricing() {
        return this.get(true);
    }
}
